import styled from "@emotion/styled";
import {Card} from "antd";

export const Window = styled(Card)`
  width: 100%;
  max-width: 600px;
`
